/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Policy status */
export enum PolicyStatus {
  Active,
  Inactive,
  Draft,
  UnderReview,
  Deprecated,
  Suspended,
}

export type PolicyStatusArgs = PolicyStatus;

export function getPolicyStatusEncoder(): FixedSizeEncoder<PolicyStatusArgs> {
  return getEnumEncoder(PolicyStatus);
}

export function getPolicyStatusDecoder(): FixedSizeDecoder<PolicyStatus> {
  return getEnumDecoder(PolicyStatus);
}

export function getPolicyStatusCodec(): FixedSizeCodec<
  PolicyStatusArgs,
  PolicyStatus
> {
  return combineCodec(getPolicyStatusEncoder(), getPolicyStatusDecoder());
}
